import { useState } from 'react'
import PropTypes from 'prop-types'
import { format, toZonedTime } from 'date-fns-tz'
import { useTranslation } from 'react-i18next'

import Icon from '../Icons'
import ModalContainer from '../ModalContainer/ModelContainer'

import ParkingInfoSection from './components/ParkingInfoSection'

const ParkingServicesShortInfo = ({ data }) => {
  const { t } = useTranslation(['parking', 'common'])
  const [modalOpen, toggleModal] = useState(false)

  const renderCostOptions = () => {
    const filteredOptions = data.costSettings.filter((option) => option.enabled)
    const elements = []
    for (let i = 0; i < filteredOptions.length; i++) {
      const item = filteredOptions[i]
      elements.push(
        <div className="row">
          <div>
            {i === 0 ? '0' : filteredOptions[i - 1].duration}-{item.duration}{' '}
            {t('parking:servicesShortInfo.hoursSuffix')}
          </div>
          <div>
            {item.price === 0 ? t('parking:servicesShortInfo.free') : `$${item.price / 100}`}
          </div>
        </div>,
      )
    }

    return elements
  }

  const dateStart = toZonedTime(new Date(data.startTime), data.timezone)
  return (
    <ParkingInfoSection title={t('parking:servicesShortInfo.title')}>
      <div className="parking-info__section-row">
        <div className="parking-info__section-info parking-info__section-info--top">
          <div className="parking-info__section-info-key">
            <Icon icon="timer" /> {t('parking:servicesShortInfo.startTime')}
          </div>
          <div className="parking-info__section-info-value">
            {data.startTime ? format(dateStart, 'hh:mm a') : ''}
          </div>
          <div style={{ fontSize: '14px' }}>
            {data.startTime ? format(dateStart, 'MMM do') : ''}
          </div>
        </div>
        <div className="parking-info__section-info parking-info__section-info--top">
          <div className="parking-info__section-info-key">
            <Icon icon="tagIcon" /> {t('parking:servicesShortInfo.ticketNo')}
          </div>
          <div className="parking-info__section-info-value">{data.ticketNumber}</div>
        </div>
      </div>
      <button
        onClick={() => toggleModal(true)}
        data-testid="services-cost-info"
        className="button button-black parking-info__services-info-button"
      >
        {t('parking:servicesShortInfo.getFamiliar')}
      </button>
      {modalOpen && (
        <ModalContainer hideHeader isResponsive additionalClass="parking-modal">
          <div className="row header">
            <div>{t('parking:servicesShortInfo.servicesCostTitle')}</div>
          </div>
          {renderCostOptions()}
          <button onClick={() => toggleModal(false)} className="button is-black full-width">
            {t('common:actions.close')}
          </button>
        </ModalContainer>
      )}
    </ParkingInfoSection>
  )
}

ParkingServicesShortInfo.propTypes = {
  data: PropTypes.object,
}

export default ParkingServicesShortInfo
